/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2L12 22M2 9L12 9M11.9999 15H21.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12 2L12 22M2 9L12 9M12 15H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 2.85C11.25 2.28995 11.25 2.00992 11.141 1.79601C11.0451 1.60785 10.8922 1.45487 10.704 1.35899C10.4901 1.25 10.2101 1.25 9.65 1.25H7.91667C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25L9.65 9.25C10.2101 9.25 10.4901 9.25 10.704 9.14101C10.8922 9.04513 11.0451 8.89215 11.141 8.70399C11.25 8.49008 11.25 8.21005 11.25 7.65V2.85ZM9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75L9.65 10.75C10.2101 10.75 10.4901 10.75 10.704 10.859C10.8922 10.9549 11.0451 11.1078 11.141 11.296C11.25 11.5099 11.25 11.7899 11.25 12.35V13.9903C11.25 13.9935 11.2499 13.9968 11.2499 14C11.2499 14.0032 11.25 14.0065 11.25 14.0097L11.25 21.15C11.25 21.7101 11.25 21.9901 11.141 22.204C11.0451 22.3922 10.8922 22.5451 10.704 22.641C10.4901 22.75 10.2101 22.75 9.65 22.75H9.25ZM14.35 14.75C13.7899 14.75 13.5099 14.75 13.296 14.859C13.1078 14.9549 12.9549 15.1078 12.859 15.296C12.75 15.5099 12.75 15.7899 12.75 16.35L12.75 21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H16.0833C17.6333 22.75 18.4083 22.75 19.0441 22.5796C20.7696 22.1173 22.1173 20.7696 22.5796 19.0441C22.75 18.4083 22.75 17.6333 22.75 16.0833C22.75 15.7733 22.75 15.6183 22.7159 15.4912C22.6235 15.1461 22.3539 14.8765 22.0088 14.7841C21.8817 14.75 21.7267 14.75 21.4167 14.75H14.35ZM21.15 13.25C21.7101 13.25 21.9901 13.25 22.204 13.141C22.3922 13.0451 22.5451 12.8922 22.641 12.704C22.75 12.4901 22.75 12.2101 22.75 11.65V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H14.35C13.7899 1.25 13.5099 1.25 13.296 1.35899C13.1078 1.45487 12.9549 1.60785 12.859 1.79601C12.75 2.00992 12.75 2.28995 12.75 2.85V10V11.65C12.75 12.2101 12.75 12.4901 12.859 12.704C12.9549 12.8922 13.1078 13.0451 13.296 13.141C13.5099 13.25 13.7899 13.25 14.35 13.25H21.15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 2L12 22M12 9L4 9H2.00111C2.00876 6.84993 2.06911 5.66397 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10L21.9989 11M12 15H21.9989C21.9912 17.1501 21.9309 18.336 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 2L12 22M2 9L12 9M12 15H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 2.85C11.25 2.28995 11.25 2.00992 11.141 1.79601C11.0451 1.60785 10.8922 1.45487 10.704 1.35899C10.4901 1.25 10.2101 1.25 9.65 1.25H7.91667C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25L9.65 9.25C10.2101 9.25 10.4901 9.25 10.704 9.14101C10.8922 9.04513 11.0451 8.89215 11.141 8.70399C11.25 8.49008 11.25 8.21005 11.25 7.65V2.85ZM14.35 14.75C13.7899 14.75 13.5099 14.75 13.296 14.859C13.1078 14.9549 12.9549 15.1078 12.859 15.296C12.75 15.5099 12.75 15.7899 12.75 16.35L12.75 21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H16.0833C17.6333 22.75 18.4083 22.75 19.0441 22.5796C20.7696 22.1173 22.1173 20.7696 22.5796 19.0441C22.75 18.4083 22.75 17.6333 22.75 16.0833C22.75 15.7733 22.75 15.6183 22.7159 15.4912C22.6235 15.1461 22.3539 14.8765 22.0088 14.7841C21.8817 14.75 21.7267 14.75 21.4167 14.75H14.35Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 14.75V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75L9.65 10.75C10.2101 10.75 10.4901 10.75 10.704 10.859C10.8922 10.9549 11.0451 11.1078 11.141 11.296C11.25 11.5099 11.25 11.7899 11.25 12.35V13.9903L11.2499 14L11.25 14.0097L11.25 21.15C11.25 21.7101 11.25 21.9901 11.141 22.204C11.0451 22.3922 10.8922 22.5451 10.704 22.641C10.4901 22.75 10.2101 22.75 9.65 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75Z"
				fill="currentColor"
			/>
			<path
				d="M22.75 9.25V11.65C22.75 12.2101 22.75 12.4901 22.641 12.704C22.5451 12.8922 22.3922 13.0451 22.204 13.141C21.9901 13.25 21.7101 13.25 21.15 13.25H14.35C13.7899 13.25 13.5099 13.25 13.296 13.141C13.1078 13.0451 12.9549 12.8922 12.859 12.704C12.75 12.4901 12.75 12.2101 12.75 11.65V10V2.85C12.75 2.28995 12.75 2.00992 12.859 1.79601C12.9549 1.60785 13.1078 1.45487 13.296 1.35899C13.5099 1.25 13.7899 1.25 14.35 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
